import { NgModule } from '@angular/core';
import { NoClickDirective } from './events/no-click.directive';
import { IfPermissionDirective } from '@app/directives/if-permission/if-permission.directive';
import { ClassSelectorDirective } from './class-selector/class-selector.directive';
import { ModalDirective } from './modal/modal.directive';
import { WfsStatusBadgeDirective } from '@app/directives/wfs-status-badge/wfs-status-badge.directive';
import { ToggleDirective } from '@app/directives/toggle/toggle.directive';

const DIRECTIVES = [
	ClassSelectorDirective,
	IfPermissionDirective,
	ModalDirective,
	NoClickDirective,
	ToggleDirective,
	WfsStatusBadgeDirective,
];

@NgModule({
	declarations: DIRECTIVES,
	exports: DIRECTIVES,
})
export class GlobalDirectivesModule {}
